export class InvoicingModelDetailImport {
  counter: number = 0;
  invoicingModelId: number = 0;
  consecutiveInvoicingModel: number = 0;
  conceptInvoicingCode: number = 0;
  conceptInvoicingCodeAlter: string | null = null;
  swAiu: boolean = false;
  invoiceNumber: number = 0;
  saleAccount: string | null = null;
  saleDevolutionAccount: string | null = null;
  ivaTaxCode: string | null = null;
  rtfTaxCode: string | null = null;
  constructor(
    counter: number = 0,
    invoicingModelId: number = 0,
    consecutiveInvoicingModel: number = 0,
    conceptInvoicingCode: number = 0,
    conceptInvoicingCodeAlter: string | null = null,
    swAiu: boolean = false,
    invoiceNumber: number = 0,
    saleAccount: string | null = null,
    saleDevolutionAccount: string | null = null,
    ivaTaxCode: string = "",
    rtfTaxCode: string = ""
  ) {
    this.counter = counter;
    this.invoicingModelId = invoicingModelId;
    this.consecutiveInvoicingModel = consecutiveInvoicingModel;
    this.conceptInvoicingCode = conceptInvoicingCode;
    this.conceptInvoicingCodeAlter = conceptInvoicingCodeAlter;
    this.swAiu = swAiu;
    this.invoiceNumber = invoiceNumber;
    this.saleAccount = saleAccount;
    this.saleDevolutionAccount = saleDevolutionAccount;
    this.ivaTaxCode = ivaTaxCode;
    this.rtfTaxCode = rtfTaxCode;
  }
}